module.exports = __webpack_public_path__ + "img/corrin-min.9736b267.png";